/**
 * 메모리 사용률의 기준 (22-C회차, 사용자 피드백 21).
 *
 * 22-C 전에는 `usedBytes / totalBytes`였다. `totalBytes`는 V8이 **확보한** 힙이라 사용량을 따라
 * 늘고 줄어, 비율이 늘 80~97%로 나왔다. 카드의 "90% 초과"와 알림 `heap_used_pct` 85%가 헛경보를 냈다.
 * 22-C부터 에이전트가 V8 힙 **상한**(`v8.getHeapStatistics().heap_size_limit`)을 `limitBytes`로
 * 보내고, 있으면 그것 대비로 잰다. 옛 에이전트(값 없음)는 예전처럼 확보한 힙 대비다.
 *
 * 콘솔 카드·서버 알림·외부 API가 전부 이 함수를 쓴다. 기준이 세 곳에 따로 있으면 어긋난다.
 */

export interface HeapLike {
  usedBytes: number;
  totalBytes: number;
  limitBytes?: number;
}

/** 비율의 분모. 상한이 있으면 상한, 없으면 확보한 힙 */
export function heapBasisBytes(heap: HeapLike): number {
  return heap.limitBytes !== undefined && heap.limitBytes > 0 ? heap.limitBytes : heap.totalBytes;
}

/** 분모가 상한인지(새 에이전트). 아니면 확보한 힙 기준이라 화면이 그 사실을 적는다 */
export function heapBasisIsLimit(heap: HeapLike): boolean {
  return heap.limitBytes !== undefined && heap.limitBytes > 0;
}

/** 0~1. 분모가 0이면 0 */
export function heapUsedRatio(heap: HeapLike): number {
  const basis = heapBasisBytes(heap);
  return basis > 0 ? heap.usedBytes / basis : 0;
}

/** 0~100. 분모가 0이면 0 */
export function heapUsedPct(heap: HeapLike): number {
  return heapUsedRatio(heap) * 100;
}
